import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

interface AuthCodeResponse { token: string; }

@Injectable({ providedIn: 'root' })
export class AuthService {
  private apiBase = environment.apiHost + '/makpak';

  constructor(private http: HttpClient) {}

  // Exchanges authorization code for CIAM login token
  public sendAuthCode(authCode: string): Observable<HttpResponse<AuthCodeResponse>> {
    return this.http.post<AuthCodeResponse>(`${this.apiBase}/auth/code`, { authCode }, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      observe: 'response'
    });
  }
}